export const HOW_IT_WORKS_LABEL = {
  'Unsubscribe Message': {
    action: () => {
      window.open('https://support.identxlabs.com/en/getting-started/editing-unsubscribe-message', '_blank', 'noopener,noreferrer');
    },
  },
};
